import React from 'react'
import ProductQuantityInput from '../QuantityInput'
import currencyFormatter from 'currency-formatter'
import { Button } from '@mui/material'
import { Trans, useTranslation } from 'react-i18next'
import FormattedPrice from '@components/FormattedPrice'

interface IProps {
  selectedVariant: any
  quantity: number
  add?: boolean

  checkVariantAvailability(): boolean
  onChangeQuantity(val: number): void
  onUpdateBag(e: any): void
  onAddToBagFullKit(e: any): void
  onCustomizeKit(e: any): void
}

const ProductFormEditButtons: React.FC<IProps> = ({
  checkVariantAvailability,
  selectedVariant,
  quantity,
  onChangeQuantity,
  onUpdateBag,
  onAddToBagFullKit,
  onCustomizeKit,
  add,
}) => {
  const { t } = useTranslation()
  if (!selectedVariant) {
    return (
      <div>
        <Button variant='contained' color='primary' size='large' onClick={onUpdateBag} fullWidth disabled>
          {add ? t('button.addToBag', 'Add to bag') : t('button.updateBag', 'Update bag')}
        </Button>
      </div>
    )
  }

  const inBagDigital = selectedVariant.isInCart && !selectedVariant.shippingRequired
  const canChangeQuantity = selectedVariant.shippingRequired && checkVariantAvailability()
  const isSupply = selectedVariant.isSupply
  const isAvailable = checkVariantAvailability()

  return (
    <div>
      {!isSupply && (
        <div className='flex items-center'>
          {canChangeQuantity && (
            <ProductQuantityInput
              quantity={quantity}
              availableQuantity={selectedVariant.stockQuantity}
              onChangeQuantity={onChangeQuantity}
              cartQuantity={selectedVariant.stockQuantity}
            />
          )}
          <div className='flex-1'>
            <Button
              variant='contained'
              color='primary'
              size='large'
              disabled={!isAvailable || inBagDigital}
              onClick={onUpdateBag}
              fullWidth
            >
              {inBagDigital
                ? t('button.alreadyInTheBag', 'Already in the bag')
                : add
                ? t('button.addToBag', 'Add to bag')
                : t('button.updateBag', 'Update bag')}
            </Button>
          </div>
        </div>
      )}
      {isSupply && (
        <>
          <Button
            variant='contained'
            color='primary'
            size='large'
            onClick={onAddToBagFullKit}
            disabled={!isAvailable}
            fullWidth
          >
            <Trans
              i18nKey='button.addToBagFullKitPrice'
              defaults='Add to bag <price/>'
              components={{
                price: (
                  <FormattedPrice
                    currency={selectedVariant.priceRange.currency}
                    amount={selectedVariant.priceRange.discount.max}
                  />
                ),
              }}
            />
          </Button>
          {selectedVariant.isCustomizable && (
            <>
              <div className='my-5' />
              <Button
                variant='outlined'
                color='primary'
                size='large'
                onClick={onCustomizeKit}
                disabled={!isAvailable}
                fullWidth
              >
                {t('button.customizeTheKit', 'Customize the KIT')}
              </Button>
            </>
          )}
        </>
      )}
    </div>
  )
}

export default React.memo(ProductFormEditButtons)
